/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-subtract': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M4.375 9.375h11.25v1.25H4.375z" _fill="#000" fill-rule="evenodd"/>'
  }
})
